import type { Meta, StoryObj } from "@storybook/react";

import NetworkStatusBanner from "@/ui/components/common/NetworkStatusBanner";

const StoryMeta: Meta<typeof NetworkStatusBanner> = {
  title: "Components/Common/Network Status Banner",
  component: NetworkStatusBanner,
};

type Story = StoryObj<typeof NetworkStatusBanner>;

const Default: Story = {
  name: "Network Status Banner",
};

export default StoryMeta;
export { Default };
